import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Form from 'antd/es/form';
import Input from 'antd/es/input';
import notification from 'antd/es/notification';
import Button from 'antd/es/button';
import './style.less';

import ArrowRightOutlined from '@ant-design/icons/ArrowRightOutlined';
import {
  GetMeAction,
  SendOTPToChangePhoneNumber,
  VerifyOTPToChangePhoneNumber,
  VerifyToChangePhoneNumberOfCompanyOrUser,
} from '../action';
import { useTranslation } from 'react-i18next';
import '../../../translations/i18n';

import Sidebar from '../../distributor/view/component/Sidebar/Sidebar';
import StickyTop from './profile/stickytop';
import Countdown from 'antd/lib/statistic/Countdown';
import { useDispatch } from 'react-redux';

const ChangePhoneNumber = () => {
  const { t } = useTranslation();
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const inputPhoneNumber = useRef();

  const [loader, setLoader] = useState(false);
  const [inputDisable, setInputDisable] = useState(false);

  const [showOtp, setShowOtp] = useState(true);
  const [timer, setTimer] = useState(Date.now());

  const onFinish = async (values) => {
    if (inputPhoneNumber.current.input.value.length < 10)
      return notification.error({
        message: `Invalid Mobile Number`,
      });

    values.phone_number_to_change = inputPhoneNumber.current.input.value;
    setLoader(true);
    const { message: msg, error: err } = await VerifyOTPToChangePhoneNumber(
      values,
    );
    console.log(msg, err);

    if (!err) {
      const { error, message, data } =
        await VerifyToChangePhoneNumberOfCompanyOrUser({
          phone_number: inputPhoneNumber.current.input.value,
          edit_your_own_phone_no: true,
        });
      setLoader(false);

      console.log(message, error, data);
      if (error) {
        notification.error({
          message: error,
          description: message,
        });
      } else {
        if (data && data.token) {
          localStorage.setItem('token', data.token);
          let { error: userError, data: loggedInUser } = await GetMeAction();
          if (!userError && loggedInUser) {
            dispatch({ type: 'SET_USER', data: loggedInUser });
            localStorage.setItem('user', JSON.stringify(loggedInUser));
          }
        }

        notification.success({
          message: t('success'),
        });

        localStorage.clear();
        dispatch({ type: 'LOGOUT' });
      }
      setLoader(false);
    } else {
      notification.error({
        message: `OTP Error`,
      });
      setLoader(false);
    }
  };
  const sendOtpHandler = async () => {
    if (inputPhoneNumber.current.input.value.length < 10)
      return notification.error({
        message: `Invalid Mobile Number`,
      });

    setInputDisable(true);

    if (timer > Date.now()) return;
    setTimer(Date.now() + 60 * 1000);
    setShowOtp(false);

    const { error, message } = await SendOTPToChangePhoneNumber({
      phone_number: inputPhoneNumber.current.input.value,
      edit_your_own_phone_no: true,
    });
    console.log(message, error);

    if (error) {
      notification.error({
        message: 'Error',
        description: message,
      });
    } else {
      notification.success({
        message: `OTP Sent To both number`,
      });
    }
  };

  // when timer over resend otp will show
  function onTimerOver() {
    setShowOtp(true);
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <Sidebar />
      <div className='container newChange new' style={{ flex: 1 }}>
        <StickyTop />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <div className={'reg-container'}>
            <div
              className={'register register1'}
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  marginTop: '3rem',
                }}
              >
                {/* <ScreenBack /> */}
                <div className={'humbee changeNumber-title'}>
                  {t('profile.changePhoneNumber')}
                </div>
                <div className={'registerForm regform'}>
                  <div
                    className={'otpContainer otpContainer-change_phoneNumber'}
                  >
                    <Form.Item
                      name='phoneNumber'
                      label={`${t('login.usernamePlaceholderNew')}`}
                      rules={[{ required: true, message: t('optRequired') }]}
                    >
                      <Input
                        ref={inputPhoneNumber}
                        disabled={inputDisable}
                        maxLength={10}
                        inputMode='numeric'
                        size='large'
                        minLength={10}
                        placeholder={t('login.usernamePlaceholderNew')}
                        onKeyPress={(e) => {
                          const key = e.key;
                          if (
                            (key !== '.' && isNaN(key)) ||
                            (key === '.' && e.target.value.includes('.'))
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>

                    {showOtp === false ? (
                      <div className='counter'>
                        <div className='counterTimer displayCenter'>
                          <div>
                            <p className='counter-text'>
                              {t('login.resendAfter')}
                            </p>
                          </div>
                          <div>
                            <Countdown
                              className={'loginCounter loginCounterRetailer'}
                              value={timer}
                              format='ss'
                              onFinish={onTimerOver}
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className={'resendText'}>
                        <p onClick={sendOtpHandler} className='send_otp'>
                          Send OTP
                        </p>
                      </div>
                    )}
                  </div>

                  <Form
                    layout={'vertical'}
                    name='register'
                    onFinish={onFinish}
                    autoComplete='off'
                  >
                    <Form.Item
                      label={t('verify.otpForOldNumber')}
                      name='otp_to_existing_phone_number'
                      rules={[
                        {
                          required: true,
                          message: 'OTP is required',
                        },
                      ]}
                    >
                      <Input
                        maxLength={4}
                        minLength={4}
                        placeholder={'OTP'}
                        inputMode={'numeric'}
                        onKeyPress={(e) => {
                          const key = e.key;
                          if (
                            (key !== '.' && isNaN(key)) ||
                            (key === '.' && e.target.value.includes('.'))
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                    <Form.Item
                      label={t('verify.otpForNewNumber')}
                      name='otp_to_change_phone_number'
                      rules={[
                        {
                          required: true,
                          message: 'OTP is required',
                        },
                      ]}
                    >
                      <Input
                        maxLength={4}
                        minLength={4}
                        placeholder={'OTP'}
                        inputMode={'numeric'}
                        onKeyPress={(e) => {
                          const key = e.key;
                          if (
                            (key !== '.' && isNaN(key)) ||
                            (key === '.' && e.target.value.includes('.'))
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                    {/* <p>
                      {t("verify.codeNotReceived")}{" "}
                      <span
                        className={"otp-resend-href"}
                        id="resend-otp"
                        onClick={sendOtpHandler}
                      >
                        {t("verify.resend")}
                      </span>{" "}
                    </p> */}

                    <Form.Item>
                      <Button
                        loading={loader}
                        block={true}
                        type='primary'
                        htmlType='submit'
                        className={'btn'}
                      >
                        <b className={'btnText'}>{t('update')}</b>
                        <ArrowRightOutlined className={'btnArrow'} />
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePhoneNumber;
